import React from "react";
import { useLanguage } from "../context/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-line bg-white py-14"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-8 md:gap-x-12 items-end">
          <div className="col-span-12 md:col-span-6">
            <p className="font-serif-display text-3xl text-ink leading-none">
              Ivan Bautista
            </p>
            <p className="mt-3 text-sm text-ink-soft max-w-md">
              {t.footer.tagline}
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 md:text-right">
            <p className="eyebrow mb-2">ivanbautista.es</p>
            <p className="text-xs text-muted-foreground">
              © {year} Ivan Bautista. {t.footer.rights}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
